var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRateReviewStar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 47,
    viewBox: "0 0 49 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.598 39.1198C25.0281 38.8199 24.3471 38.8196 23.7768 39.1189L13.2263 44.6573C11.7901 45.4112 10.1126 44.1914 10.3873 42.5927L12.4013 30.8704C12.5106 30.2342 12.2993 29.5851 11.8364 29.1352L3.29896 20.8379C2.13416 19.7058 2.77535 17.7295 4.38288 17.4969L16.1664 15.7918C16.804 15.6995 17.3554 15.2994 17.6408 14.7219L22.9159 4.05006C23.6343 2.59664 25.707 2.59664 26.4254 4.05006L31.7005 14.7219C31.986 15.2994 32.5373 15.6995 33.1749 15.7918L44.9585 17.4969C46.566 17.7295 47.2072 19.7058 46.0424 20.8379L37.505 29.1352C37.0421 29.5851 36.8307 30.2342 36.94 30.8704L38.9532 42.5881C39.228 44.1876 37.5489 45.4075 36.1126 44.6518L25.598 39.1198Z",
    fill: "#354D9E",
    stroke: "#354D9E",
    strokeWidth: 0.734043,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2706 30.157H28.2996V31.1592H20.6107V30.3605L25.1677 25.8976C26.4048 24.6761 26.6397 23.9401 26.6397 23.1885C26.6397 21.92 25.7471 21.1371 24.0715 21.1371C22.7874 21.1371 21.8009 21.5285 21.0805 22.3585L20.2819 21.6695C21.1275 20.6673 22.4899 20.1035 24.1654 20.1035C26.3891 20.1035 27.7985 21.231 27.7985 23.0632C27.7985 24.1124 27.4696 25.0519 25.9976 26.4926L22.2706 30.157Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRateReviewStar2);
export default __webpack_public_path__ + "static/media/IconRateReviewStar-2.04d0413a71db7189274a4863e68b1ca1.svg";
export { ForwardRef as ReactComponent };